import { Skeleton, Stack, useTheme } from "@mui/material";
import { FormTextFieldSkeleton, SkeletonFormGroup } from "components/Skeleton";

// This component can change but it's a good starting point for a skeleton
export const TaskDialogSkeleton: React.FC = () => {
  const theme = useTheme();
  return (
    <Stack gap={theme.spacing(3)} paddingBottom={theme.spacing(3)}>
      <SkeletonFormGroup count={1} />
      <FormTextFieldSkeleton kind="short" />
      <Stack direction="row" gap={theme.spacing(1)}>
        <Skeleton variant="rounded" width="100%" height={50} />
        <Skeleton variant="rounded" width="100%" height={50} />
        <Skeleton variant="rounded" width="100%" height={50} />
        <Skeleton variant="rounded" width="100%" height={50} />
        <Skeleton variant="rounded" width="100%" height={50} />
      </Stack>
    </Stack>
  );
};
